// Pure helper — no React / UI imports so it can be unit-tested in Jest
// without dealing with the project's path aliases.
//
// Map an event_type_code into one of three operator-facing categories.
// Operator's mental model from the timeline:
//   Aduana    — customs / SOIA / pedimento / liberación / inspección
//   Transporte — booking / zarpe / arribo a puerto / salida de puerto / status changes
//   Almacén   — Pantaco / destino / entrega / Ferrovalle final stages
//
// Substring-based (case-insensitive) so it tolerates BOTH the seeded catalog
// codes (BOOKING_CONFIRMADO, LIBERACION…) AND the dynamic ones the scrapers
// emit (soia_*, status_*). Unknown codes fall through to `otros` so the user
// can still see them when they click the "Todos" chip.
export function classifyEventCategory(code) {
  const c = String(code || '').toLowerCase();
  if (!c) return 'otros';
  if (
    c.startsWith('soia_') ||
    c.includes('aduana') ||
    c.includes('pedimento') ||
    c.includes('liberacion') ||
    c.includes('liberación') ||
    c.includes('despacho') ||
    c.includes('inspeccion') ||
    c.includes('inspección') ||
    c.includes('semaforo') ||
    c.includes('reconocimiento') ||
    c.includes('desanuadizado') ||
    c.includes('desaduanado')
  ) return 'aduana';
  if (
    c.includes('pantaco') ||
    c.includes('destino') ||
    c.includes('entrega') ||
    c.includes('entregado') ||
    c.includes('almacen') ||
    c.includes('almacén') ||
    c.includes('warehouse') ||
    c.includes('descarga')
  ) return 'almacen';
  if (
    c.includes('booking') ||
    c.includes('zarpe') ||
    c.includes('arribo') ||
    c.includes('arribado') ||
    c.includes('puerto') ||
    c.includes('salida') ||
    c.includes('transito') ||
    c.includes('tránsito') ||
    c.includes('embarque') ||
    c.includes('ferro') ||
    c.includes('tren') ||
    c.includes('camion') ||
    c.includes('camión') ||
    c.includes('transit') ||
    c.includes('rail') ||
    c.includes('discharge') ||
    c.startsWith('status_en_transito') ||
    c.startsWith('status_arribado') ||
    c.startsWith('status_en_puerto') ||
    c.startsWith('status_no_salido')
  ) return 'transporte';
  return 'otros';
}
